module.exports = __webpack_public_path__ + "92986b97a42995382ea3f8d3847acb0e.MP3";